/* eslint-disable dot-notation */
import Vue from 'vue'
import Vuex from 'vuex'
import * as firebase from 'firebase'

Vue.use(Vuex)

export default ({
  state: {
    loadedChannelIds: [],
    loadedChannelData: []
  },
  mutations: {
    createChannelId (state, payload) {
      state.loadedChannelIds.push(payload)
    },
    setLoadedChannelIds (state, payload) {
      state.loadedChannelIds = payload
    },
    deleteChannel (state, payload) {
      for (var i = 0; i < state.loadedChannelIds.length; i++) {
        if (state.loadedChannelIds[i].id === payload) {
          state.loadedChannelIds.splice(i, 1)
        }
      }
    },
    setChannelData (state, payload) {
      state.loadedChannelData = payload
    }
  },
  actions: {
    saveChannelData ({ commit }) {
      commit('setLoading', true)
      firebase.database().ref('stats').once('value')
        .then((data) => {
          const channels = []
          const obj = data.val()
          for (const key in obj) {
            channels.push({
              id: key,
              averageViews: obj[key].averageViews,
              date: obj[key].date,
              subCount: obj[key].subCount,
              userId: obj[key].userId,
              viewCount: obj[key].viewCount
            })
            const youTubeKey = 'AIzaSyA8Z2osd9n1J9rO3oQfv7u5joxOhyMJsCY'
            fetch(`https://youtube.googleapis.com/youtube/v3/channels?part=snippet%2CcontentDetails%2Cstatistics&id=${obj[key].userId}&key=${youTubeKey}`)
              .then(response => {
                return response.json()
              })
              .then(data => {
                // eslint-disable-next-line dot-notation
                obj[key].date.push(new Date().toISOString().split('T')[0])
                obj[key].subCount.push(data['items'][0].statistics.subscriberCount)
                obj[key].viewCount.push(data['items'][0].statistics.viewCount)
                obj[key].averageViews.push(parseInt(data['items'][0].statistics.viewCount / data['items'][0].statistics.videoCount))
                firebase.database().ref('stats').child(key).update(obj[key])
                  .then(() => {
                    commit('setLoading', false)
                  })
                  .catch(error => {
                    console.log(error)
                    commit('setLoading', false)
                  })
              })
          }
          commit('setLoading', false)
        })
        .catch((error) => {
          commit('setLoading', false)
          console.log(error)
        })
    },
    createChannelId ({ commit }, payload) {
      const youTubeKey = 'AIzaSyA8Z2osd9n1J9rO3oQfv7u5joxOhyMJsCY'
      fetch(`https://youtube.googleapis.com/youtube/v3/channels?part=snippet%2CcontentDetails%2Cstatistics&id=${payload.userId}&key=${youTubeKey}`)
        .then(response => {
          return response.json()
        })
        .then(data => {
          // eslint-disable-next-line dot-notation
          const info = {
            userId: payload.userId,
            date: [new Date().toISOString().split('T')[0]],
            subCount: [data['items'][0].statistics.subscriberCount],
            viewCount: [data['items'][0].statistics.viewCount],
            averageViews: [parseInt(data['items'][0].statistics.viewCount / data['items'][0].statistics.videoCount)]
          }
          firebase.database().ref('stats').push(info)
            .then((data) => {
              // console.log(data)
            })
          commit('createChannelId', info)
        })
    },
    loadChannelIds ({ commit }) {
      commit('setLoading', true)
      firebase.database().ref('stats').once('value')
        .then((data) => {
          const data1 = []
          const obj = data.val()
          for (const key in obj) {
            data1.push({
              id: key,
              averageViews: obj[key].averageViews,
              date: obj[key].date,
              subCount: obj[key].subCount,
              userId: obj[key].userId,
              time: obj[key].time,
              viewCount: obj[key].viewCount
            })
          }
          commit('setLoading', false)
          commit('setChannelData', data1)
        })
        .catch((error) => {
          commit('setLoading', false)
          console.log(error)
        })
    },
    loadChannelDatas ({ commit }) {
      commit('setLoading', true)
      firebase.database().ref('stats').once('value')
        .then((data) => {
          const youTubeKey = 'AIzaSyA8Z2osd9n1J9rO3oQfv7u5joxOhyMJsCY'
          const ids = []
          const obj = data.val()
          for (const key in obj) {
            fetch(`https://youtube.googleapis.com/youtube/v3/channels?part=snippet%2CcontentDetails%2Cstatistics&id=${obj[key].userId}&key=${youTubeKey}`)
              .then(response => {
                return response.json()
              })
              .then(data => {
                // eslint-disable-next-line dot-notation
                const publishedDate = data['items'][0].snippet.publishedAt
                const splitDate = publishedDate.split('T')
                ids.push({
                  id: key,
                  userId: obj[key].userId,
                  country: data['items'][0].snippet.country,
                  subCount: data['items'][0].statistics.subscriberCount,
                  viewCount: data['items'][0].statistics.viewCount,
                  videoCount: data['items'][0].statistics.videoCount,
                  channelName: data['items'][0].snippet.title,
                  averageViews: parseInt(data['items'][0].statistics.viewCount / data['items'][0].statistics.videoCount),
                  createdDate: splitDate[0],
                  thumbnail: data['items'][0].snippet.thumbnails.default.url
                })
              })
          }
          commit('setLoading', false)
          commit('setLoadedChannelIds', ids)
        })
        .catch((error) => {
          commit('setLoading', false)
          console.log(error)
        })
    },
    loadChannelData ({ commit }) {
      commit('setLoading', true)
      firebase.database().ref('stats').once('value')
        .then((data) => {
          const youTubeKey = 'AIzaSyA8Z2osd9n1J9rO3oQfv7u5joxOhyMJsCY'
          const ids = []
          const obj = data.val()
          for (const key in obj) {
            fetch(`https://youtube.googleapis.com/youtube/v3/channels?part=snippet%2CcontentDetails%2Cstatistics&id=${obj[key].userId}&key=${youTubeKey}`)
              .then(response => {
                return response.json()
              })
              .then(data => {
                // eslint-disable-next-line dot-notation
                const publishedDate = data['items'][0].snippet.publishedAt
                const splitDate = publishedDate.split('T')
                ids.push({
                  id: key,
                  userId: obj[key].userId,
                  country: data['items'][0].snippet.country,
                  subCount: data['items'][0].statistics.subscriberCount,
                  viewCount: data['items'][0].statistics.viewCount,
                  videoCount: data['items'][0].statistics.videoCount,
                  channelName: data['items'][0].snippet.title,
                  averageViews: parseInt(data['items'][0].statistics.viewCount / data['items'][0].statistics.videoCount),
                  createdDate: splitDate[0],
                  thumbnail: data['items'][0].snippet.thumbnails.default.url
                })
              })
          }
          commit('setLoading', false)
        })
        .catch((error) => {
          commit('setLoading', false)
          console.log(error)
        })
    },
    deleteChannel ({ commit }, payload) {
      firebase.database().ref('stats').child(payload).remove()
      commit('deleteChannel', payload)
    }
  },
  getters: {
    loadedChannelIds (state) {
      return state.loadedChannelIds.sort((userA, userB) => {
        return userA.userId > userB.userId
      })
    },
    loadedChannelId (state) {
      return (userId) => {
        return state.loadedChannelIds.find((user) => {
          return user.userId === userId
        })
      }
    },
    loadedChannelDatas (state) {
      return state.loadedChannelData.sort((userA, userB) => {
        return userA.userId > userB.userId
      })
    },
    loadedChannelData (state) {
      return (userId) => {
        return state.loadedChannelData.find((user) => {
          return user.userId === userId
        })
      }
    }
  }
})
